module.exports = __webpack_public_path__ + "static/media/IE.116f300a.svg";